import { makeVar } from "@apollo/client"
import { AddExtraDataPackageResult } from "@phonero/common-graphql/types"
import { appStorage, updateReactiveVarAndAddToLocalStorage, parseLocalStorageValueAndFilterOutOldIffContainsDate } from "@phonero/common-ux"

export const appVars = {
  lastRead: makeVar<Record<string, Date>>({}),
  lastReadReceipts: makeVar<Record<string, Date>>({}),
}

/** Used to track purchases to third-parties with redirects.
 *
 * In practicce, they are used for Vipps-payments, where we add an additional failsafe in case of
 * OS-specific failures/misconfigurations in handling app-redirects both to and from Vipps.
 *
 * */
const uncompletedPurchasesVar = makeVar<Record<string, IncompletePurchase> | null>(null)

appStorage.get({ key: "uncompletedPurchases" }).then((v) => {
  if (!v.value) {
    return
  }
  const reduced = parseLocalStorageValueAndFilterOutOldIffContainsDate<IncompletePurchase>(v.value)
  uncompletedPurchasesVar(reduced)
})

const uncompletedPurchasesUpdater = updateReactiveVarAndAddToLocalStorage(uncompletedPurchasesVar,  "uncompletedPurchases")

export type IncompletePurchase = Pick<AddExtraDataPackageResult, "orderID" | "productID" | "paymentMethod" | "paymentURI"
> & { date: Date; productText: string; productName: string; productID: string | number; amount: number, paymentID: string, isRedirected: boolean, paymentURI: string } & {
  source: "localStorage" | "server"
}

export const uncompletedPurchases = {
  var: uncompletedPurchasesVar,
  update: uncompletedPurchasesUpdater,
  remove: (paymentId: string) =>
    uncompletedPurchasesUpdater((state) => {
      if (!state) {
        return {}
      }
      const { [paymentId]: _omit, ...rest } = state
      return rest
    }),
  clear: () => uncompletedPurchasesUpdater({}),
  add: (purchase: IncompletePurchase) =>
    uncompletedPurchasesUpdater((s) => ({
      ...s,
      // @ts-ignore: source is specified more than once
      [purchase.paymentID]: { source: "localStorage", ...purchase },
    })),
}

export const useBadgeCounter = () => {
  // const { purchases } = useUncompletedPurchases()
  // const location = useLocation()
  // const isPaymentCallback = matchPath(location.pathname, {
  //   path: routes.paymentCallbackVipps.path,
  // })

  // let count = 0

  // if (!isPaymentCallback) {
  //   // don't show a badge-count for payments on the payment-callback-page
  //   count += Object.keys(purchases || {}).length
  // }

  // return count
  return 0
}

